import React, { useState, useEffect } from 'react';
import './Layout.css';
import '../../../src/App.css';
import Sidebar from '../SideBar/Sidebar';
import FooterSection from '../Footer/FooterSection';
import { Layout } from 'antd';
import Navbar from '../Navbar/Navbar';
import MobileViewLayout from './MobileLayout/MobileViewLayout';

const { Content, Header } = Layout;

function AppLayout({ children }) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      // Set isMobile to true if the screen width is less than or equal to 768px
      setIsMobile(window.innerWidth <= 1023);
    };

    // Initial check
    handleResize();

    // Listen htmlFor window resize
    window.addEventListener('resize', handleResize);

    // Cleanup the listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="min-w-[360px]">
      {isMobile ? (
        // Render MobileViewLayout if the screen width is mobile-sized
        <MobileViewLayout page={children} />
      ) : (
        // Render desktop layout htmlFor larger screens
        <Layout style={{ minHeight: '100vh' }}>
          {/* Sidebar */}
          <Sidebar />

          <Layout>
            {/* Navbar */}
            <Navbar />

            <Content
              style={{
                minHeight: '360px',
                backgroundColor: 'var(--background-color)',
                overflowY: 'auto',
              }}
            >
              {/* Render main content */}
              {children}
            </Content>

            <FooterSection />
          </Layout>
        </Layout>
      )}
    </div>
  );
}

export default AppLayout;
